import styled from "styled-components";
import {Person, Product, Project, StyledBaseProps} from "@betrue/shared/interfaces";
import React from "react";
import {Button, Grid} from "@mui/material";
import {LoginLogoutContainer, ProductButtonProps} from "@betrue/ui";
import {toSnakeCase} from "@betrue/shared/utils";
import {Skeleton} from "@mui/material";

export interface ProductButtonViewProps extends StyledBaseProps, ProductButtonProps {
  addProduct: (p: Product) => void
  deleteProduct: (p: Product) => void
  project: Project
  principal?: Person
}

export const ProductButtonView = styled((props: ProductButtonViewProps) => (
  <div className={props.className}>
    {props.principal ?
      (
        <Grid container direction={"column"} spacing={1} justifyContent={"center"} alignContent={"center"}
              alignItems={"center"}>
          <Grid item xs={12}>
            <p
              className={"card-price"}>{props.startingPriceLabel ? props.startingPriceLabel : 'à partir de'} {props.minPrice}€</p>
          </Grid>
          <Grid item xs={12}>
            {props.project.selectedProducts?.find((it) => it.slug === toSnakeCase(props.dynamicButtonValue)) ? (
              <Button onClick={() => {
                const product = props.project.selectedProducts?.find((it) => {
                  if (it.slug === toSnakeCase(props.dynamicButtonValue)) {
                    return it
                  }
                })
                props.deleteProduct(product)

              }}
                      variant="outlined" color="secondary">
                {props.dynamicButtonDeleteLabel}
              </Button>) : (
              <Button
                disabled={!props.project || !!props.project.selectedProducts?.find((it) => it.slug === toSnakeCase(props.dynamicButtonValue))}
                onClick={() => props.addProduct({
                  name: props.dynamicButtonValue,
                  slug: toSnakeCase(props.dynamicButtonValue),
                  maxPrice: props.maxPrice,
                  minPrice: props.minPrice
                } as Product)} variant="outlined" color="primary">
                {props.dynamicButtonAddLabel}
              </Button>)}
          </Grid>
        </Grid>
      ) : (<Grid container direction={"column"} spacing={1} justifyContent={"center"} alignContent={"center"}
                 alignItems={"center"}>
        <Grid item xs={12}>
          <Skeleton variant="text"/>
          <p>{props.offlineNotice ? props.offlineNotice : 'Pour afficher le prix vous devez vous connecter'}</p>
        </Grid>
        <Grid item xs={12}>
          <LoginLogoutContainer logoutLabel={"se déconnecter"} loginLabel={'Se connecter'}/>
        </Grid>
      </Grid>)}
  </div>

))` & {
  .card-price {
    margin: 0;
    padding: 0;
    color: ${(props) => props.theme.colors.accent}
  }
}
`
